import { useMemo, useState } from 'react';
import { NumberField, SelectField, QuickChips, ResultPanel, ResultItem, ResultNote } from './fields';
import { useAnimatedNumber } from './AnimatedNumber';
import { PAIRS, LEVERAGES } from './pairs';

export const MARGIN_ACCENT = '#7C3AED';

export default function MarginCalculator() {
  const [pair, setPair] = useState('EURUSD');
  const [lots, setLots] = useState(1);
  const [leverage, setLeverage] = useState('500');

  const pairMeta = useMemo(() => PAIRS.find((p) => p.value === pair) ?? PAIRS[0], [pair]);
  const leverageNum = parseInt(leverage, 10) || 1;

  const margin = (lots * pairMeta.unitValue) / leverageNum;
  const animatedMargin = useAnimatedNumber(margin);

  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <SelectField
          label="Cặp tiền tệ"
          value={pair}
          onChange={setPair}
          options={PAIRS.map((p) => ({ value: p.value, label: p.label }))}
          accent={MARGIN_ACCENT}
        />
        <SelectField
          label="Đòn bẩy"
          value={leverage}
          onChange={setLeverage}
          options={LEVERAGES}
          accent={MARGIN_ACCENT}
        />
        <div className="sm:col-span-2">
          <NumberField
            label="Khối lượng lệnh"
            value={lots}
            onChange={setLots}
            suffix="lot"
            min={0.01}
            step={0.01}
            accent={MARGIN_ACCENT}
          />
          <div className="mt-2">
            <QuickChips options={[0.01, 0.1, 0.5, 1, 2]} value={lots} onChange={setLots} />
          </div>
        </div>
      </div>

      <div className="mt-6">
        <ResultPanel accent={MARGIN_ACCENT}>
          <ResultItem label="Ký quỹ yêu cầu" value={`$${animatedMargin.toFixed(2)}`} accent={MARGIN_ACCENT} big />
          <ResultNote>
            Với đòn bẩy 1:{leverageNum}, giá trị hợp đồng 1 lot ≈ ${pairMeta.unitValue.toLocaleString('vi-VN')}
          </ResultNote>
        </ResultPanel>
      </div>
    </>
  );
}